import { Modal, Select, Table } from 'antd';
import { useEffect, useState } from 'react';

import type { ColumnsType, TablePaginationConfig } from 'antd/lib/table';
import type { FilterValue, SorterResult } from 'antd/lib/table/interface';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { getEnv } from '../../../helpers/mobx-easy-wrapper';
const { Option } = Select;
interface DataType {
    assignEndAt: string;
    orgField: string;
    score: number;
    scoreStatus: number;
    status: number;
    type: string;
    worksName: string;
    id: string;
}

interface Params {
    pagination?: TablePaginationConfig;
    sorter?: SorterResult<any> | SorterResult<any>[];
    total?: number;
    sortField?: string;
    sortOrder?: string;
}
const statusMap = {
    0: '未审核',
    1: '审核失败',
    2: '审核成功',
    3: '初评',
    4: '复评',
};
const scoreStatusMap = {
    0: '未评分',
    1: '草稿',
    2: '已评分',
};

const columns: ColumnsType<DataType> = [
    {
        title: '项目名称',
        dataIndex: 'worksName',
        width: '20%',
    },
    {
        title: '分类',
        dataIndex: 'type',
        width: '10%',
    },
    {
        title: '项目领域',
        dataIndex: 'orgField',
    },
    {
        title: '评分阶段',
        dataIndex: 'status',
        render: (_, { status }) => <>{(statusMap as any)[status]}</>,
    },
    {
        title: '评分截止日期',
        dataIndex: 'assignEndAt',
        render: (_, { assignEndAt }) => <>{moment(assignEndAt).format('YYYY年MM月DD日 HH:mm')}</>,
    },
    {
        title: '评分状态',
        dataIndex: 'scoreStatus',
        render: (_, { scoreStatus }) => <>{(scoreStatusMap as any)[scoreStatus]}</>,
    },
    {
        title: '评分',
        dataIndex: 'score',
    },
    {
        title: '操作',
        dataIndex: 'action',
        render: (_, record) => (
            <span className='action'>
                {record.scoreStatus === 0 && <a href={`/expert/score/${record.id}`}>开始评分 </a>}
                {record.scoreStatus === 1 && <a href={`/expert/score/${record.id}`}>继续评分 </a>}
                {record.scoreStatus === 2 && <a href={`/expert/score/${record.id}`}>查看 </a>}
            </span>
        ),
    },
];
const getRandomuserParams = (params: Params) => ({
    results: params.pagination?.pageSize,
    page: params.pagination?.current,
    ...params,
});
let timer: any = 0;
const showReport = !window.localStorage.getItem('report');

const Home = () => {
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);

    const [orgField, setOrgField] = useState('');
    const [type, setType] = useState('');
    const [status, setStatus] = useState('');
    const [counts, setCounts] = useState([0, 0, 0]);

    const [visible, setVisible] = useState(showReport);
    const [timerNum, setTimerNum] = useState(5);
    const { apiFactory } = getEnv();
    const { hash } = useLocation();

    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        defaultPageSize: 10,
        showSizeChanger: false,
        position: ['bottomCenter'],
        hideOnSinglePage: true,
    });
    setTimeout(() => {
        // @ts-ignore
        window.history.replaceState(null, null, ' ');
    }, 200);

    useEffect(() => {
        // fetchData({ pagination });
        const getScoreList = async () => {

            const filterStatusMap = {
                未评分: 0,
                草稿: 1,
                已评分: 2,
            };
            // @ts-ignore
            const scoreList = await apiFactory.techService.scoreList(type, orgField, filterStatusMap[status] as any);
            let unScoreCount = 0;
            let draftCount = 0;
            let scoredCount = 0;
            scoreList.filter((score: any) => {
                switch (score.scoreStatus) {
                    case 0:
                        unScoreCount++;
                        break;
                    case 1:
                        draftCount++;
                        break;
                    case 2:
                        scoredCount++;
                        break;
                    default:
                        unScoreCount++;
                        return;
                }
            });
            setCounts([unScoreCount, draftCount, scoredCount]);
            // @ts-ignore
            setData([...scoreList]);

            // @ts-ignore
            timer = setInterval(() => {
                setTimerNum((v) => {
                    return v - 1;
                });
            }, 1000);
            // console.log('data', data);
        };
        getScoreList();
    }, [orgField, status, type]);
    useEffect(() => {
        if (timerNum == 0) {
            // setVisible(false)
            clearInterval(timer);
        }
    }, [timerNum]);

    const handleTableChange = (newPagination: TablePaginationConfig, filters: Record<string, FilterValue>, sorter: SorterResult<DataType>) => {
        /*fetchData({
                sortField: sorter.field as string,
                sortOrder: sorter.order as string,
                pagination: newPagination,
                ...filters,
            });*/
    };
    const handleOk = () => {
        setVisible(false);
    };

    const handleCancel = () => {
        setVisible(false);
        window.localStorage.setItem('report', '1');
    };

    return (
        <>
            {visible && (
                <Modal
                    visible={true}
                    centered={true}
                    closable={false}
                    footer={[
                        <button
                            key={'closeButton'}
                            type='button'
                            className={timerNum > 0 ? `lite__sub__button event-disabled` : 'lite__sub__button'}
                            onClick={handleCancel}
                        >
                            接受{timerNum > 0 ? `（${timerNum}）` : ''}
                        </button>,
                    ]}
                >
                    <div
                        dangerouslySetInnerHTML={{
                            __html: `<p style="text-align: center;"><strong>评议专家承诺书</strong></p> <p style="text-indent: 24pt;">经“2024上海市首届高价值专利大赛”（以下简称“上高赛”）组委会邀请，本人作为本届上高赛的评议专家，将承诺严格遵守以下事项：</p><p style="text-indent: 24pt;">1、严格遵守有关评议的规定，保证在评议过程中做到公平、公正；</p><p style="text-indent: 24pt;">2、恪守信用，自觉维护参赛主体的合法权益，保证不将本人在评选过程中所接触到的项目的技术、商业机密等信息透露给第三方，这些信息包括但不限于观点、想法、创意及其他智力成果、技术方法、商业计划等；</p><p style="text-indent: 24pt;">3、自觉遵守职业道德，正确行使评议权，严格按照上高赛评议规则，客观、公正、实事求是、专业独立地进行评议，提出评议意见，并对所提出的评议意见承担个人责任；</p><p style="text-indent: 24pt;">4、本人与参赛主体/项目有直接或间接利害关系时，应当主动提出回避。利害关系包括：</p><p style="text-indent: 24pt;">（1）评议专家本人在参赛主体/项目中任职的；</p><p style="text-indent: 24pt;">（2）评议专家的亲属在参赛主体/项目中担任主要职务的；</p><p style="text-indent: 24pt;">（3）评议专家本人或评议专家所在/所有企业或机构在参赛企业/团队中有投资或者占有股份的；</p><p style="text-indent: 24pt;">（4）与参赛主体/项目有其他社会关系或经济利益关系，可能影响公正履行职责的。</p><p style="text-indent: 24pt;">5、在评议时，本人将不直接接触参赛主体/项目。如需联系沟通，须通过上高赛组委会进行，以确保评议过程的公正性和透明度；</p><p style="text-indent: 24pt;">6、无论在评议时或评议后，未经上高赛组委会授权，本人将不向外界透露任何评议内容；</p><p style="text-indent: 24pt;">7、在评议期间，不发表任何具有倾向性、诱导性或歧视性的见解，若因本人原因所发生的违反评议纪律、社会道德和相关法律等方面的问题，本人愿意承担一切相应后果及法律责任。</p>`,
                        }}
                    />
                </Modal>
            )}
            <div className='expertContainer'>
                <div className='expert_table_header'>
                    <div className={'expert_search'}>
                        <div className='item label'>项目分类</div>
                        <div className='item search_contrl'>
                            {/*     <Select    defaultValue="全部"  style={{width: 70}} size={'small'} onClick={handleSelectChange}>
                        <Option value="全部">全部</Option>
                        <Option value="企业">企业</Option>
                        <Option value="高校">高校</Option>
                    </Select>*/}
                            <div className='option'>
                                <select
                                    name=''
                                    value={type}
                                    onChange={(e) => {
                                        setType(e.target.value);
                                    }}
                                >
                                    <option value=''>全部</option>
                                    <option value='企业'>企业</option>
                                    <option value='高校'>高校</option>
                                </select>
                            </div>
                        </div>
                        <div className='item label'>项目领域</div>
                        <div className='item search_contrl' style={{ width: 145 }}>
                            {/*<Select    defaultValue="全部"  style={{width: 100}} size={'small'} onClick={handleSelectChange}>
                        <Option value="全部">全部</Option>
                        <Option value="新材料">新材料</Option>
                        <Option value="医疗用品">医疗用品</Option>
                    </Select>*/}
                            <div className='option'>
                                <select
                                    name=''
                                    value={orgField}
                                    onChange={(e) => {
                                        setOrgField(e.target.value);
                                    }}
                                >
                                    <option value=''>全部</option>
                                    <option value={'集成电路'}>集成电路</option>
                                    <option value={'生物医药（药类）'}>生物医药（药类）</option>
                                    <option value={'生物医药（器械类）'}>生物医药（器械类）</option>
                                    <option value={'人工智能'}>人工智能</option>
                                    <option value={'新能源汽车'}>新能源汽车</option>
                                    <option value={'高端装备'}>高端装备</option>
                                    <option value={'航空航天'}>航空航天</option>
                                    <option value={'信息通信'}>信息通信</option>
                                    <option value={'新材料'}>新材料</option>
                                    <option value={'新兴数字产业'}>新兴数字产业</option>
                                    <option value={'绿色低碳'}>绿色低碳</option>
                                    <option value={'未来产业'}>未来产业</option>
                                    <option value={'农业科技'}>农业科技</option>
                                    <option value={'食品科技'}>食品科技</option>
                                    {/* <option value={'集成电路'}>集成电路</option>
                                    <option value={'生物医药'}>生物医药</option>
                                    <option value={'人工智能'}>人工智能</option>
                                    <option value={'新能源汽车'}>新能源汽车</option>
                                    <option value={'高端装备制造'}>高端装备制造</option>
                                    <option value={'航天航空'}>航天航空</option>
                                    <option value={'信息通讯'}>信息通讯</option>
                                    <option value={'新材料'}>新材料</option>
                                    <option value={'新兴数字产业'}>新兴数字产业</option>
                                    <option value={'光子芯片与器件'}>光子芯片与器件</option>
                                    <option value={'基因与细胞技术'}>基因与细胞技术</option>
                                    <option value={'类脑智能'}>类脑智能</option>
                                    <option value={'新型海洋经济'}>新型海洋经济</option>
                                    <option value={'氢能与储能'}>氢能与储能</option>
                                    <option value={'第六代移动通讯'}>第六代移动通讯</option> */}
                                    <option value={'其他'}>其他</option>
                                </select>
                            </div>
                        </div>
                        <div className='item label'>评分状态</div>
                        <div className='item search_contrl' style={{ width: 90 }}>
                            {/*<Select    defaultValue="全部"  style={{width: 80}} size={'small'} onClick={handleSelectChange}>
                        <Option value="未评分">未评分</Option>
                        <Option value="已提交">已提交</Option>
                    </Select>*/}
                            <div className='option'>
                                <select
                                    name=''
                                    value={status}
                                    onChange={(e) => {
                                        setStatus(e.target.value);
                                    }}
                                >
                                    <option value=''>全部</option>
                                    <option value={'未评分'}>未评分</option>
                                    <option value={'草稿'}>草稿</option>
                                    <option value={'已评分'}>已评分</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className={'smallBlock'}>
                        <div className='num'>{counts[0]}</div>
                        <div className='title'>未评分</div>
                    </div>
                    <div className={'smallBlock'}>
                        <div className='num'>{counts[1]}</div>
                        <div className='title'>草稿箱</div>
                    </div>
                    <div className={'smallBlock'}>
                        <div className='num'>{counts[2]}</div>
                        <div className='title'>已评分</div>
                    </div>
                </div>
                <div style={{ padding: '40px 50px', background: '#FFF' }}>
                    <Table
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={data}
                        pagination={false}
                        loading={loading}
                    /*          onChange={handleTableChange as any}*/
                    />
                </div>
            </div>
        </>
    );
};

export default Home;
